import en from './en.json'
import it from './it.json'

export const operatorTranslations = {
	en,
	it
} as const
